import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import './TextRow.scss'
import PageComponent from './PageComponent'
import joinClassNames from '../../helpers/joinClassNames'
import cmsMarkdownRenderers from '../../helpers/markdown/cmsMarkdownRenderers'

const getPositionClassName = (position) => {
    const placement = !position || position === 'center' ? 'centered' : position
    return `has-text-${placement}`
}

const TextRow = ({content, backgroundColor, contentAlignment}) => {
    return (
        <PageComponent backgroundColor={backgroundColor}>
            <div className={joinClassNames('page__text-row', getPositionClassName(contentAlignment))}>
                <ReactMarkdown source={content} escapeHtml={false} renderers={cmsMarkdownRenderers} />
            </div>
        </PageComponent>
    )
}

TextRow.propTypes = {
    id: PropTypes.string,
    content: PropTypes.string,
    backgroundColor: PropTypes.string,
}

TextRow.defaultProps = {
    content: '',
    backgroundColor: 'white',
}

export default TextRow
